import * as React from "react"

// Minimal, build-safe placeholder toast utilities. We now use `sonner` for real toasts.
// These are kept to satisfy any imports without causing type or build errors.

export function ToastProvider({ children }: { children: React.ReactNode }) {
  return children as any
}

export function Toast(props: React.HTMLAttributes<HTMLDivElement>) {
  return React.createElement('div', props)
}

export function ToastTitle(props: React.HTMLAttributes<HTMLDivElement>) {
  return React.createElement('div', props)
}

export function ToastDescription(props: React.HTMLAttributes<HTMLDivElement>) {
  return React.createElement('div', props)
}

export function useToast() {
  return {
    toasts: [] as any[],
    toast: (_args?: any) => ({ id: "noop", dismiss() {}, update() {} }),
    dismiss: (_id?: string) => {},
  }
}
